$(document).ready(function () {
  setTimeout(function () {
    var currency_rate =
      parseFloat($('#product_data_price').attr('data-usd-price')) /
      parseFloat($('#product_data_price').attr('data-price'));

    var recharge_bundle_price = parseFloat($('#rechange_bundle_price').attr('data_rechange_price'));
    var currency_price = Math.floor(recharge_bundle_price / currency_rate);
    $('#rechange_bundle_price').text('$' + currency_price); //
    var double_trouble_price = parseFloat($('#double_trouble_price').attr('data_trouble_price'));
    var currency_double_price = Math.floor(double_trouble_price / currency_rate);
    $('#double_trouble_price').text('$' + currency_double_price);

    var double_trouble_original_price = parseFloat(
      $('#double_trouble_original_price').attr('data_trouble_original_price')
    );
    var currency_original_price = Math.floor(double_trouble_original_price / currency_rate);
    $('#double_trouble_original_price').text('$' + currency_original_price);

    $("input[name='bundle_option_number']").removeAttr('disabled');
  }, 500);
  const checkboxes = document.querySelectorAll('input[name="bundle_option_number"]');
  const addon_product_checkbox = document.getElementById('addon_product');

  checkboxes.forEach((checkbox, index) => {
    if (index == 0) {
      setTimeout(function () {
        checkbox.click();
      }, 600);
    }

    checkbox.addEventListener('change', function () {
      checkboxes.forEach((chekb, index) => {
        chekb.disabled = false;
      });
      checkbox.disabled = true;
      let selectedQuantitySets = this.value;
      if (this.value > 1) {
        selectedQuantitySets = selectedQuantitySets + ' Sets';
      } else {
        selectedQuantitySets = selectedQuantitySets + ' Set';
      }
      let selectedQuantitySetEle =
        this.closest('.bundle--block')?.previousElementSibling?.querySelector('.selected-quantity-set');
      if (this.checked) {
        selectedQuantitySetEle.textContent = selectedQuantitySets;
      } else {
        selectedQuantitySetEle.textContent = '';
      }
      let addonProductsContainerEle = this.closest('.product-container').querySelector('.addon-products-container');
      if (addonProductsContainerEle) {
        if (this.value == 2) {
          addonProductsContainerEle.querySelectorAll('input')?.forEach((input) => {
            input.checked = false;
          });
          addonProductsContainerEle.classList.add('hide');
        } else {
          if (addonProductsContainerEle.classList.value.includes('hide')) {
            addonProductsContainerEle.classList.remove('hide');
          }
        }
      }

      var original_comepare_price = $('.product-price').attr('data-compare_price');
      var original_sale_price = $('.product-price').attr('data-price'); //
      if (this.checked) {
        var bundle_origina_price = $(this).closest('.bundle--item').find('.original--price').text();
        var bundle_item = $(this).closest('.bundle--item');
        if (bundle_item.hasClass('double-bundle-item')) {
          var bundle_price = $(this).closest('.bundle--item').find('.bundle--item--price').text();
        } else {
          var bundle_price = $(this).closest('.bundle--item').find('.bundle--item--price-of-product').text();
        }
        if (addon_product_checkbox) {
          if (addon_product_checkbox.checked) {
            let new_original_price = parseFloat($(this).closest('.bundle--item').attr('data-new-price'));
            let addon_product_price = parseFloat($('.addon-products').attr('data-addon-product-price'));
            let new_price = parseFloat(new_original_price + addon_product_price);
            $('.all-product-price').text('$' + new_price);
            $('.variant-price').text('$' + new_price);
          } else {
            $('.all-product-price').text(bundle_price);
            $('.variant-price').text(bundle_price);
          }
        } else {
          $('.all-product-price').text(bundle_price);
          $('.variant-price').text(bundle_price);
        }
        $('.product-price del:first-of-type').text(bundle_origina_price);
        $('.product-price p:first-of-type').text(bundle_price);

        checkboxes.forEach((cb) => {
          if (cb !== this) {
            cb.checked = false;
          }
        });
      } else {
        if (addon_product_checkbox) {
          if (addon_product_checkbox.checked) {
            let asf = parseFloat($('.product-price').attr('data-price'));
            let asf_pr = asf / 100;
            let addon_product_price = parseFloat($('.addon-products').attr('data-addon-product-price'));
            let new_price = parseFloat(asf_pr + addon_product_price);
            $('.all-product-price').text('$' + new_price);
            $('.variant-price').text('$' + new_price);
          } else {
            $('.all-product-price').text('$' + original_sale_price / 100);
            $('.variant-price').text('$' + original_sale_price / 100);
          }
        } else {
        }
        $('.product-price del:first-of-type').text('$' + original_comepare_price / 100);
        $('.product-price p:first-of-type').text('$' + original_sale_price / 100);
      }
    });
  });

  if (addon_product_checkbox) {
    addon_product_checkbox.addEventListener('change', function () {
      var original_sale_price = $('.product-price').attr('data-price'); //
      if (addon_product_checkbox.checked) {
        let anyChecked = false;
        checkboxes.forEach((checkbox) => {
          if (checkbox.checked) {
            anyChecked = true;
          }
        });
        if (anyChecked) {
          let new_original_price = parseFloat(
            $("input[name='bundle_option_number']:checked").closest('.bundle--item').attr('data-new-price')
          );
          let addon_product_price = parseFloat($('.addon-products').attr('data-addon-product-price'));
          let new_price = parseFloat(new_original_price + addon_product_price);
          $('.all-product-price').text('$' + new_price);
          $('.variant-price').text('$' + new_price);
        } else {
          let asf = parseFloat($('.product-price').attr('data-price'));
          let asf_pr = asf / 100;
          let addon_product_price = parseFloat($('.addon-products').attr('data-addon-product-price'));
          let new_price = parseFloat(asf_pr + addon_product_price);
          $('.all-product-price').text('$' + new_price);
          $('.variant-price').text('$' + new_price);
        }
      } else {
        let anyChecked = false;
        checkboxes.forEach((checkbox) => {
          if (checkbox.checked) {
            anyChecked = true;
          }
        });
        if (anyChecked) {
          let new_original_price = parseFloat(
            $("input[name='bundle_option_number']:checked").closest('.bundle--item').attr('data-new-price')
          );
          $('.all-product-price').text('$' + new_original_price);
          $('.variant-price').text('$' + new_original_price);
        } else {
          $('.all-product-price').text('$' + original_sale_price / 100);
          $('.variant-price').text('$' + original_sale_price / 100);
        }
      }
    });
  }

  $(document).on('click', '#add_to_cart_alternative', function () {
    var bundle_id = $('input[id="bundle_variant_id"]').val();
    var main_product_id = $('#main_product_id').val();
    let addon_pro_id = $('input[name="addon_product"]:checked').attr('data-var-id');
    var real_quantity = $(this).closest('.form--actions').find('.js-qty__num').val();
    var quantity_obj = $('input[name="bundle_option_number"]:checked');
    let addon_product = $('input[name="addon_product"]:checked');
    if (quantity_obj.length > 0) {
      var quantity = parseInt($('input[name="bundle_option_number"]:checked').val());

      // Create an array of items to add to the cart
      var items = [
        {
          id: main_product_id, // Second product (main product)
          quantity: quantity,
        },
      ];

      if (quantity != 1) {
        items.push({
          id: bundle_id, // First product (bundle)
          quantity: quantity,
        });
      }

      if (addon_product.length > 0) {
        items.push({
          id: addon_pro_id,
          quantity: 1,
        });
      }

      // Make a single AJAX request to add both products at once
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify({ items: items }),
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
          console.log('Products added to cart:', data);
          // Update cart count
          $('.cart-item-count').text(data.item_count);
          // Trigger cart drawer open

          // Trigger cart update
          document.dispatchEvent(new CustomEvent('cart:build'));
          new theme.CartDrawer();
          document.dispatchEvent(new CustomEvent('cart:open'));
        },
        error: function (xhr, status, error) {
          console.error('Error adding products to cart:', error);
        },
      });
    } else if (addon_product.length > 0) {
      // Create an array of items to add to the cart
      var items = [
        {
          id: addon_pro_id, // First product (bundle)
          quantity: 1,
        },
        {
          id: main_product_id, // Second product (main product)
          quantity: 1,
        },
      ];

      // Make a single AJAX request to add both products at once
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify({ items: items }),
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
          console.log('Products added to cart:', data);
          // Update cart count
          $('.cart-item-count').text(data.item_count);
          // Trigger cart drawer open

          // Trigger cart update
          document.dispatchEvent(new CustomEvent('cart:build'));
          new theme.CartDrawer();
          document.dispatchEvent(new CustomEvent('cart:open'));
        },
        error: function (xhr, status, error) {
          console.error('Error adding products to cart:', error);
        },
      });
    } else {
      $('.add-to-cart:first').trigger('click');
    }
  });

  // $(document).on("click", "#add_to_cart_alternative", function() {
  //     var bundle_id = $('input[id="bundle_variant_id"]').val();
  //     var real_quantity = $(this).closest(".form--actions").find(".js-qty__num").val()
  //     var quantity_obj = $('input[name="bundle_option_number"]:checked');
  //     if(quantity_obj.length > 0) {
  //         var quantity = parseInt($('input[name="bundle_option_number"]:checked').val()) * real_quantity;
  //         $.ajax({
  //             type: 'POST',
  //             url: '/cart/add.js',
  //             data: {
  //                 id: bundle_id, // Replace with the variant ID of the product you want to add
  //                 quantity: quantity
  //             },
  //             dataType: 'json',
  //             success: function(data) {
  //                 console.log('First product added to cart:', data);
  //                 // Call the function to trigger the current "Add to Cart" action here
  //                 //$('.add-to-cart:first').trigger('click');
  //                 var main_product_id = $('#main_product_id').val();
  //                 $.ajax({
  //                     type: 'POST',
  //                     url: '/cart/add.js',
  //                     data: {
  //                         id: main_product_id, // Replace with the variant ID of the product you want to add
  //                         quantity: quantity
  //                     },
  //                     dataType: 'json',
  //                     success: function(data) {
  //                         console.log('Second product added to cart:', data);
  //                         // Call the function to trigger the current "Add to Cart" action here
  //                         //$('.add-to-cart:first').trigger('click');
  //                         //var main_product_id = $('input[name="id"]').val();

  //                     },
  //                     error: function(xhr, status, error) {
  //                         console.error('Error adding product to cart:', error);
  //                     }
  //                 });
  //             },
  //             error: function(xhr, status, error) {
  //                 console.error('Error adding product to cart:', error);
  //             }
  //         });
  //     } else {
  //         $('.add-to-cart:first').trigger('click');
  //     }

  // });

  // accordion code

  var accItem = document.getElementsByClassName('accordionItem');
  var accHD = document.getElementsByClassName('accordionItemHeading');
  for (i = 0; i < accHD.length; i++) {
    accHD[i].addEventListener('click', toggleItem, false);
  }
  function toggleItem() {
    var itemClass = this.parentNode.className;
    for (i = 0; i < accItem.length; i++) {
      accItem[i].className = 'accordionItem close';
    }
    if (itemClass == 'accordionItem close') {
      this.parentNode.className = 'accordionItem open';
    }
  }

  // review slider in product page

  const customer_review = new Swiper('.customer-review', {
    slidesPerView: 1.1,
    spaceBetween: 10,
    loop: true,
    centeredSlides: true,
    pagination: {
      el: '.customer-review .slider__pagination',
      clickable: true,
    },
    breakpoints: {
      1025: {
        slidesPerView: 1.5,
      },
    },
  });
});

document.addEventListener('DOMContentLoaded', function () {
  let play_button = document.getElementById('play-button-label');

  if (play_button) {
    function addParameterToIframe() {
      var iframe = document.getElementById('youtubePlayer');
      var iframeSrc = iframe.src;
      var newParameter = 'autoplay=1&mute=1';

      if (iframeSrc.indexOf('?') === -1) {
        if (iframeSrc.indexOf('autoplay=1&mute=1') === -1) {
          iframeSrc += '?' + newParameter;
        }
      } else {
        if (iframeSrc.indexOf('autoplay=1&mute=1') === -1) {
          iframeSrc += '&' + newParameter;
        }
      }
      iframe.src = iframeSrc;
      console.log('iframeSrc ', iframeSrc);
      console.log(iframe.src);

      // Get the parent div and add the 'active' class when playing
      var parentDiv = iframe.closest('.video-wrapper-main');
      if (parentDiv) {
        parentDiv.classList.add('active');
      }

      var videoTextContent = document.querySelector('.video-text-content');
      if (videoTextContent) {
        videoTextContent.style.display = 'none';
      }
    }
    play_button.addEventListener('click', addParameterToIframe);
  }

  // Use the YouTube Player API to detect play and pause events
  var iframe = document.getElementById('youtubePlayer');
  if (iframe) {
    var player = new YT.Player(iframe, {
      events: {
        onStateChange: onPlayerStateChange,
      },
    });
  }
});

let cardSlider = null;
let main_product_image_container = null;

function initSliders() {
  if (window.innerWidth < 769) {
    if (!cardSlider) {
      cardSlider = new Swiper('.cardSlider', {
        slidesPerView: 1.03,
        spaceBetween: 10,
        loop: false,
        navigation: {
          nextEl: '.cardSlider .swiper-button-next',
          prevEl: '.cardSlider .swiper-button-prev',
        },
      });
    }

    if (!main_product_image_container) {
      main_product_image_container = new Swiper('.main-product-image-container', {
        slidesPerView: 1,
        loop: false,
        autoHeight: true,
        centeredSlides: true,
        pagination: {
          el: '.slider__pagination',
          clickable: true,
        },
        on: {
          slideChange: function () {
            const previousEl = document.querySelector('.main-product-image-container')?.previousElementSibling;
            if (previousEl) {
              if (this.activeIndex > 0) {
                previousEl.classList.add('hide');
              } else {
                previousEl.classList.remove('hide');
              }
            }
          },
        },
      });
    }
  } else {
    if (cardSlider) {
      cardSlider.destroy(true, true);
      cardSlider = null;
    }
    if (main_product_image_container) {
      main_product_image_container.destroy(true, true);
      main_product_image_container = null;
    }
  }
}

initSliders();

let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(initSliders, 300);
});

if (document.querySelector('#play-demo-video')) {
  document.querySelector('#play-demo-video').addEventListener('click', function () {
    if (document.querySelector('.main-product-image-container video')) {
      let demoPlayPopup = this.closest('.play-demo').querySelector('.play-demo-popup');
      let popupContentEle = this.closest('.play-demo').querySelector('.play-demo-popup .play-demo-popup-content');

      if (popupContentEle.querySelector('.popup-play-demo-video')) {
        demoPlayPopup.classList.add('hide');
        popupContentEle.innerHTML = '';
      } else {
        let demoPlayPopupClose = document.createElement('div');
        demoPlayPopupClose.classList.add('play-demo-popup-close');
        demoPlayPopupClose.textContent = 'x';
        demoPlayPopupClose.addEventListener('click', function () {
          demoPlayPopup.classList.add('hide');
          let video = popupContentEle.querySelector('video');
          if (video) {
            video.pause();
          }
        });
        popupContentEle.appendChild(demoPlayPopupClose);
        popupContentEle.querySelector('video').play();
        demoPlayPopup.classList.remove('hide');
      }

      demoPlayPopup.addEventListener('click', function (event) {
        const popupElm = event.target.querySelector('.play-demo-popup-content');
        const clickedOutsidePopup = popupElm && !popupElm.contains(event.target);
        if (clickedOutsidePopup) {
          demoPlayPopup.classList.add('hide');
          popupContentEle.querySelector('video').pause();
        }
      });
    }
  });
}

// Example: Remove an item from the cart drawer by line_item_id
function removeCartItem(line_item_id) {
  // Send AJAX request to remove the item
  fetch('/cart/change.js', {
    method: 'POST',
    body: JSON.stringify({
      line: line_item_id,
      quantity: 0,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      console.log('Item removed from cart:', data);

      // updateCartDrawer();
    })
    .catch((error) => {
      console.error('Error removing item from cart:', error);
    });
}

// Example: Attach the function to a remove button in the cart drawer
document.querySelectorAll('.remove-cart-item').forEach((button) => {
  button.addEventListener('click', function () {
    var lineItemId = parseFloat(this.getAttribute('data-line-item-id'));
    console.log('lineItemId ', lineItemId); // Assuming the line item ID is stored in a data attribute
    removeCartItem(lineItemId);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  window.setHeaderBottomOffset = function () {
    const headerEle = document.querySelector('#SiteHeader');
    let headerCurrentBottomOffset;
    if (headerEle) {
      headerCurrentBottomOffset = headerEle.getBoundingClientRect().bottom;
      if (headerCurrentBottomOffset >= 0) {
        document.documentElement.style.setProperty('--header-bottom-offset', `${headerCurrentBottomOffset}px`);
        document.documentElement.style.scrollPaddingTop = `${headerEle.getBoundingClientRect().height}px`;
      }
    }
  };
  setTimeout(setHeaderBottomOffset, 250);
  setTimeout(setHeaderBottomOffset, 250);
  window.addEventListener('resize', function () {
    setTimeout(setHeaderBottomOffset, 400);
  });
  window.addEventListener('scroll', function () {
    setTimeout(setHeaderBottomOffset, 400);
  });

  setTimeout(() => {
    const queryParams = Object.fromEntries(new URLSearchParams(window.location.search));
    if (document.querySelector('.template-collection') && queryParams.title) {
      const target = document.getElementById(queryParams.title);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, 750);
});
